import React, { Dispatch, RefObject, SetStateAction, useEffect, useRef, useState } from 'react';
import CmsBanner, { CmsBannerData } from '@chewy/cms-banner';
import '@chewy/cms-banner/dist/cms-banner.css';

type Props = {
  data: CmsBannerData;
};
const breakpoints = {
  small: { minWidth: 344, maxWidth: 616 },
  medium: { minWidth: 617 },
};

const getBannerSize = (width: number): 'small' | 'medium' => {
  if (width <= breakpoints.small.maxWidth) {
    return 'small';
  } else if (width >= breakpoints.medium.minWidth) {
    return 'medium';
  }
  return 'small';
};

const useResize = (
  bannerRef: RefObject<HTMLDivElement>,
  setBannerSize: Dispatch<SetStateAction<'small' | 'medium'>>,
): void => {
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { width } = entry.contentRect;

        setBannerSize(getBannerSize(width));
      });
    });
    if (bannerRef.current) {
      resizeObserver.observe(bannerRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

/***
   CMS banners need to be resized based on container width not screen width
   https://github.com/Chewy-Inc/cms-template-library/tree/alpha/packages/react/banner#size
 ***/
const ResizeBanner = (props: Props) => {
  const bannerRef = useRef(null);
  const [currentBannerSize, setBannerSize] = useState<'small' | 'medium'>('small');

  useResize(bannerRef, setBannerSize);

  return (
    <div data-testid="pet-profile-cms-banner" ref={bannerRef}>
      <CmsBanner data={props.data} size={currentBannerSize} />
    </div>
  );
};

export default ResizeBanner;
